module.exports = __webpack_public_path__ + "media/images/icons/outlined/minus-circle-8dd7245a6a19fdfc0a2bcb69c206e3f8.svg";